import { Box } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import Header from "./header";
import classes from "./layout.module.css";

export const Layout = ({ children }: { children: any }) => {
  const { height } = useViewportSize();
  return (
    <Box className={classes.container} style={{ minHeight: height }}>
      <Header />
      <Box className={classes.child}>{children}</Box>
    </Box>
  );
};

export default Layout;
